






































































































































import io from 'socket.io-client'
import {computed, defineComponent, onBeforeUnmount, Ref, ref, SetupContext, watch} from "@vue/composition-api"
import PaintArea from "@/games/scribble/PaintArea.vue"
import {PlayerId, PlayerState, SharedState} from "@/games/scribble/types"
import TimerPie from "@/misc/TimerPie.vue"
import {badgeLocations} from "@/rooms/BadgeLocations"

type Socket = typeof io.Socket

export default defineComponent({
  name: 'Scribble',
  components: {PaintArea, TimerPie},
  props: {
    roomId: {
      type: String,
      required: true
    },
    playerId: {
      type: String,
      required: true
    },
    socket: {
      type: Object as () => Socket,
      required: true
    },
    windowOrientation: {
      type: String,
      required: true
    }
  },
  setup({roomId, playerId, socket, windowOrientation}, {emit, root}: SetupContext) {

    const sharedState: Ref<SharedState | undefined> = ref<SharedState | undefined>()
    const playerState = ref<PlayerState | undefined>()

    socket.on('scribble : shared state', (newState: SharedState) => sharedState.value = newState)
    socket.on('scribble : player state', (newState: PlayerState) => playerState.value = newState)
    socket.on('scribble : end', () => emit('end'))

    onBeforeUnmount(() => {
      socket.off('scribble : shared state')
      socket.off('scribble : player state')
      socket.off('scribble : end')
    })

    const guess = ref('')

    watch([sharedState], () => {
      root.$store.commit('setBadges', {
        ids: Object.keys(sharedState.value?.winners ?? {}) ,
        badge: badgeLocations.trophy
      })

      if (sharedState.value?.playerIdWhoDraws !== undefined)
        root.$store.commit('setBadges', {
          ids: [sharedState.value?.playerIdWhoDraws],
          badge: badgeLocations.pencil
        })
    })

    return {
      sharedState,
      playerState,
      timer: ref(20),
      nicks: computed(() => root.$store.state.nicks as Record<string, string>),
      guess,

      selectWord: (word: string) => socket.emit('scribble : select word', word),
      sendGuess: () => {socket.emit('scribble : guess', guess.value); guess.value = ''},
      stopGame: () => socket.emit('vote', {action: 'scribble : end'}),
      onDrawChanged: () => socket.emit('scribble : draw', sharedState.value?.draw),

      sortScores: (scores: Record<PlayerId, number>) => Object.entries(scores)
        .sort((left: [string, number], right: [string, number]) => right[1] - left[1])
    }
  }
})
